import { ChatEvaluationTestExecutionResultMetrics, ChatEvaluationTestSetSample, DebugChatResult, postApiChatDebugMultipleChat, postApiChatEvaluationTestEvaluate, useGetApiChatBotDataList } from "@/API";
import { Badge, Button, Center, Divider, Group, Modal, Select, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconFlask } from "@tabler/icons-react";
import { PropsWithChildren, useState } from "react";
import { EvaluationMetricBadges } from "./MetricBadge";
import { notifications } from "@mantine/notifications";
import { modals } from "@mantine/modals";

export function EvaluateTestButton(props: { workspaceId: string, sample: ChatEvaluationTestSetSample } & PropsWithChildren) {
    const [opened, { open, close }] = useDisclosure(false);
    const [chatLoading, setChatLoading] = useState(false)
    const [testLoading, setTestLoading] = useState(false)
    const [chatBotDataId, setChatBotDataId] = useState("")
    const chatBotDataList = useGetApiChatBotDataList({ workspaceId: props.workspaceId })
    const [chatResult, setChatResult] = useState<DebugChatResult | null>()
    const [evalutateResult, setEvalutateResult] = useState<ChatEvaluationTestExecutionResultMetrics[] | null>()
    const [chatDurationMs, setChatDurationMs] = useState<number | null>(null)
    const [evaluationDurationMs, setEvaluationDurationMs] = useState<number | null>(null)
    return <>
        <div onClick={open}>
            {props.children}
        </div>
        <Modal opened={opened} onClose={close} title="評估測試" size="xl" closeOnClickOutside={false}>
            <Stack style={{ whiteSpace: "pre-wrap" }} gap={5}>
                <Text fw={600}>
                    使用者輸入
                </Text>
                <Text>
                    {props.sample.userInput}
                </Text>
                <Text fw={600}>
                    標準回應
                </Text>
                <Text >
                    {props.sample.reference}
                </Text>
                <Select
                    label="機器人設定"
                    searchable
                    data={chatBotDataList.data?.data.results?.filter(x => !!x.id).map(x => {
                        return {
                            label: x.name ?? "",
                            value: x.id ?? ""
                        }
                    })}
                    value={chatBotDataId}
                    onChange={e => setChatBotDataId(e ?? "")}
                />
            </Stack>
            <Center mt="md">
                <Button leftSection={<IconFlask />} loading={chatLoading || testLoading} onClick={async () => {
                    if (!chatBotDataId) {
                        notifications.show({ message: "請先設定機器人", color: "yellow" })
                        return
                    }
                    setChatResult(null)
                    setEvalutateResult(null)
                    setChatDurationMs(null)
                    setEvaluationDurationMs(null)

                    setChatLoading(true)
                    var _chatResult: DebugChatResult = {}
                    try {
                        const chatStartTime = performance.now()
                        var result = await postApiChatDebugMultipleChat({
                            message: props.sample.userInput,
                        }, { chatBotDataId: chatBotDataId, count: 1 })
                        const chatEndTime = performance.now()
                        setChatDurationMs(chatEndTime - chatStartTime)
                        _chatResult = result.data?.[0]
                        setChatResult(_chatResult)
                    } catch (e) {
                        notifications.show({ message: "機器人聊天失敗", color: "red" })
                    } finally {
                        setChatLoading(false)
                    }
                    if (!_chatResult?.text) return
                    setTestLoading(true)
                    try {
                        const evalStartTime = performance.now()
                        var testResult = await postApiChatEvaluationTestEvaluate([{
                            userInput: props.sample.userInput,
                            reference: props.sample.reference,
                            response: _chatResult.text,
                            retrievedContexts: _chatResult.contexts?.map(x => x.text ?? "").filter(x => !!x)
                        }], { workspaceId: props.workspaceId })
                        const evalEndTime = performance.now()
                        setEvaluationDurationMs(evalEndTime - evalStartTime)
                        setEvalutateResult(testResult.data)
                    }
                    catch (e) {
                        notifications.show({ message: "評估失敗", color: "red" })
                    } finally {
                        setTestLoading(false)
                    }
                }}>開始分析</Button>
            </Center>
            {(chatDurationMs != null || evaluationDurationMs != null) && (
                <Group gap="xs" my="xs">
                    {chatDurationMs != null && (
                        <Badge variant="outline" color="blue" size="sm">
                            對話耗時: {(chatDurationMs / 1000).toFixed(2)} s
                        </Badge>
                    )}
                    {evaluationDurationMs != null && (
                        <Badge variant="outline" color="teal" size="sm">
                            評估耗時: {(evaluationDurationMs / 1000).toFixed(2)} s
                        </Badge>
                    )}
                </Group>
            )}
            {
                (evalutateResult?.length ?? 0) > 0 &&
                <Stack gap={5} mb="sm">
                    <Text fw={600}>
                        評估結果
                    </Text>
                    <Group>
                        <EvaluationMetricBadges metricsList={evalutateResult as any} />
                    </Group>
                </Stack>
            }
            {
                chatResult &&
                <Stack gap={5}>
                    <Group gap={5}>
                        <Text fw={600}>
                            AI回應
                        </Text>
                        <Button variant="light" size="compact-xs" onClick={() => {
                            modals.open({
                                title: '擷取上下文',
                                size: "xl",
                                children: (
                                    <>
                                        {chatResult.contexts?.length == 0 && <Text>
                                            無
                                        </Text>}
                                        {chatResult.contexts?.map((x, idx) => <Stack gap={0} key={idx}>
                                            <Text style={{ whiteSpace: "pre-wrap" }}>
                                                {x.text}
                                            </Text>
                                            <Divider size="md" my="md" />
                                        </Stack>)}
                                    </>
                                ),
                            });
                        }}>
                            查看上下文
                        </Button>
                    </Group>
                    <Text style={{ whiteSpace: "pre-wrap" }}>
                        {chatResult.text}
                    </Text>
                </Stack>
            }
        </Modal>
    </>
}
